import { graphql } from "../../graphql";

export const ShareVoiceSegmentFragment = graphql(
  `fragment ShareVoiceSegmentFragment on ShareVoiceSegmentType @_unmask {
    __typename
    id
    name
    hexColor
    isVisible
    order
  }`,
);

export const ShareVoiceSidebarFilterFragment =
  graphql(`fragment ShareVoiceSidebarFilterFragment on ShareVoiceSidebar @_unmask {
      segmentColor
      segmentName
      segmentOrder
    category
    categoryLabel
    isVisible
    percentage
    segmentId
    total
}`);
